import { useMemo } from "react";
import { getBaseZipcode } from "../utils/helpers";
import useIsMergeHook from "./useIsMergeHook";
import useOrders from "./useOrders";
import useUniqueOrderColors from "./useUniqueOrderColors";

const useDeliveryOrders = (orderStatuses: number[], isMerge = false) => {
  const supportMerge = useIsMergeHook();
  const { data, isFetching, refetch } = useOrders(
    isMerge ? supportMerge : false
  );
  const orderColor = useUniqueOrderColors(data?.[0]);

  const orders = useMemo(() => {
    return (
      data?.[0]
        ?.filter(
          (order) =>
            order.order_information.delivery_method_id === 1 &&
            orderStatuses.includes(order.order_information.order_status)
        )
        .sort((a, b) => {
          if (a?.order_user?.zip_code && b?.order_user?.zip_code) {
            const aZ = getBaseZipcode(a.order_user.zip_code);
            const bZ = getBaseZipcode(b.order_user.zip_code);
            return parseInt(bZ) - parseInt(aZ);
          }
          return 0;
        })
        .map((order) => ({
          ...order,
          order_information: {
            ...order.order_information,
            order_color: orderColor[order.order_information.item_id],
          },
        })) ?? []
    );
  }, [orderColor, orderStatuses]);

  return {
    orders,
    isFetching,
    refetch,
  };
};

export default useDeliveryOrders;
